export default __webpack_public_path__ + "static/media/arco-ameaca.f7d59d27.webp";